export const getLineItemIdentity = (val_1: string, val_2: string): string =>
  `${val_1}_${val_2}`;
